import { all, put, select, takeEvery } from 'redux-saga/effects';
import { GET_MY } from '../../containers/App/constants';
import { selectCompanyProductFilterWithModifiers, selectProductFilterWithModifiers } from './selectors';
import {
  REQUEST_COMPANY_PRODUCTS,
  REQUEST_COMPANY_PRODUCTS_FILTER,
  REQUEST_PRODUCTS,
  REQUEST_PRODUCTS_FILTER
} from './constants';

function* requestProductFilter() {
  let filter = yield select(selectProductFilterWithModifiers());

  let offset = filter.offset || 0;
  let limit = filter.limit || 10;
  let text = filter.searchString?.trim() || null;
  let invoiceId = filter.invoiceId || null;
  let vehiclePurposeType = filter.vehiclePurposeType || null;

  let path = `products?offset=${offset}&limit=${limit}${text ? `&text=${text}` : ''}${
    vehiclePurposeType ? `&vehiclePurposeType=${vehiclePurposeType}` : ''
  }`;
  if (filter?.invoiceId) {
    path += `&filters[${0}][key]=invoice_id&filters[${0}][type]=single&filters[${0}][value][${0}]=${invoiceId}`;
  }

  if (filter?.options?.companyId) {
    path += `&companyId=${filter?.options?.companyId}`;
  }

  if (filter?.options?.taxRegion) {
    path += `&taxRegion=${filter?.options?.taxRegion}`;
  }

  if (filter?.options?.vehiclePurpose) {
    path += `&vehiclePurpose=${filter?.options?.vehiclePurpose}`;
  }

  let i = 0;

  if (filter?.type) {
    let type = '';
    if (filter?.type?.isCounter) {
      type = 'isCounter';
    }
    if (filter?.type?.isOneTime) {
      type = 'isOneTime';
    }

    // path += `&isCounter=${filter?.isCounter}`;
    path += `&filters[${i}][key]=${type}&filters[${i}][value][${i}]=${filter?.type[type]}&filters[${i}][type]=single`;
    ++i;
  }
  if (filter?.status) {
    // path += `&status=${filter?.status}`;
    path += `&filters[${i}][key]=status&filters[${i}][type]=single&filters[${i}][value][${i}]=${filter.status}`;
    // ++i;
  }

  yield put({
    type: GET_MY,
    id: REQUEST_PRODUCTS,
    work: REQUEST_PRODUCTS,
    gate: REQUEST_PRODUCTS,
    path,
  });
}

function* requestCompanyProductFilter() {
  let filter = yield select(selectCompanyProductFilterWithModifiers());

  let offset = filter.offset || 0;
  let limit = filter.limit || 10;
  let text = filter.searchString || null;
  let invoiceId = filter.invoiceId || null;
  let vehiclePurposeType = filter.vehiclePurposeType || null;

  let path = `company-products/company/${filter.companyId}?offset=${offset}&limit=${limit}${text ? `&text=${text}` : ''}${
    vehiclePurposeType ? `&vehiclePurposeType=${vehiclePurposeType}` : ''
  }`;
  if (filter?.invoiceId) {
    path += `&filters[${0}][key]=invoice_id&filters[${0}][type]=single&filters[${0}][value][${0}]=${invoiceId}`;
  }

  if (filter?.options?.companyId) {
    path += `&companyId=${filter?.options?.companyId}`;
  }

  if (filter?.options?.taxRegion) {
    path += `&taxRegion=${filter?.options?.taxRegion}`;
  }


  let i = 0;

  if (filter?.type) {
    let type = '';
    if (filter?.type?.isCounter) {
      type = 'isCounter';
    }
    if (filter?.type?.isOneTime) {
      type = 'isOneTime';
    }

    // path += `&isCounter=${filter?.isCounter}`;
    path += `&filters[${i}][key]=${type}&filters[${i}][value][${i}]=${filter?.type[type]}&filters[${i}][type]=single`;
    ++i;
  }
  if (filter?.status) {
    // path += `&status=${filter?.status}`;
    path += `&filters[${i}][key]=status&filters[${i}][type]=single&filters[${i}][value][${i}]=${filter.status}`;
    // ++i;
  }

  yield put({
    type: GET_MY,
    id: REQUEST_COMPANY_PRODUCTS,
    work: REQUEST_COMPANY_PRODUCTS,
    gate: REQUEST_COMPANY_PRODUCTS,
    path,
  });
}

export function* productsSaga() {
  yield all([takeEvery(REQUEST_PRODUCTS_FILTER, requestProductFilter)]);
  yield all([takeEvery(REQUEST_COMPANY_PRODUCTS_FILTER, requestCompanyProductFilter)]);
}
